import { createRoute } from "@tanstack/react-router";
import { AuthGuard } from "@/components/auth/AuthGuard";
import { MeetingsRegistry } from "@/pages/registries/MeetingsRegistry";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/meetings",
  component: MeetingsRoute,
});

function MeetingsRoute() {
  return (
    <AuthGuard>
      <MeetingsRegistry />
    </AuthGuard>
  );
}
